import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "faq-wrap" }
const _hoisted_3 = { class: "row" }

import { defineAsyncComponent } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'indexFaq',
  setup(__props) {

const FaqWidgets = defineAsyncComponent(() => import("@/components/theme/faq/FaqWidgets.vue"))
const FaqAccordion = defineAsyncComponent(() => import("@/components/theme/faq/FaqAccordion.vue"))
const FeaturedTutorial = defineAsyncComponent(() => import("@/components/theme/faq/FeaturedTutorial.vue"))
const FaqArticles = defineAsyncComponent(() => import("@/components/theme/faq/FaqArticles.vue"))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(FaqWidgets)),
        _createVNode(_unref(FaqAccordion)),
        _createVNode(_unref(FeaturedTutorial)),
        _createVNode(_unref(FaqArticles))
      ])
    ])
  ]))
}
}

})